import db, { IndexDBProduct } from "../db/db";

/**
 * Resolve product metadata from IndexedDB for purchase / purchase-return edit.
 *
 * The IndexedDB primary key `id` is the stock_masters row id, NOT the product
 * id. Saved purchase items store product_masters.id as product_id, so lookups
 * must go through the `productId` index (or `productCode`), never `db.products.get`.
 * Values may arrive as numbers or numeric strings from the API, and IndexedDB
 * compares keys strictly by type, so both forms are queried.
 */
export const findProductFromDb = async (
  productId: number | string | null | undefined,
  batchNumber?: number | string | null,
  productCode?: string | number | null,
): Promise<IndexDBProduct | null> => {
  let matches: IndexDBProduct[] = [];

  const idNum = Number(productId);
  if (Number.isFinite(idNum) && idNum > 0) {
    matches = await db.products
      .where("productId")
      .anyOf([idNum, String(idNum)])
      .toArray();
  }

  if (!matches.length && productCode != null && String(productCode) !== "") {
    const codeStr = String(productCode);
    const codeKeys: (string | number)[] = [codeStr];
    const codeNum = Number(codeStr);
    if (Number.isFinite(codeNum)) codeKeys.push(codeNum);
    matches = await db.products.where("productCode").anyOf(codeKeys).toArray();
  }

  if (!matches.length) return null;

  if (batchNumber != null && String(batchNumber) !== "") {
    const byBatch = matches.find(
      (m) => String(m.batchNumber ?? "") === String(batchNumber),
    );
    if (byBatch) return byBatch;
  }

  return matches[0] ?? null;
};
